import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { AccountingEntry } from '@interfaces'
import { Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class AccountingService {
	private http = inject(HttpClient)
	private url = '/accounting'

	getEntries(filter: {
		zone: string
		movementType: string
		dateFrom: string
		dateTo: string
	}): Observable<AccountingEntry[]> {
		return this.http.post<AccountingEntry[]>(`${this.url}/entries`, filter)
	}
}
